class VliscoContactForm {
    constructor() {
        this.init();
    }

    init() {
        this.subjectSelect = document.querySelector('#ContactForm-subject');
        this.subjectItems = document.querySelectorAll('span.subject-item');

        this.registerEvents();
    }

    registerEvents() {
        if (this.subjectItems) {
            this.subjectItems.forEach(item => {
                item.addEventListener("click", this.changeSubject.bind(this, item));
            });
        }
    }

    changeSubject(item) {
        const selectedValue = item.getAttribute("data-value");

        const option = this.subjectSelect.querySelector(`option[value="${selectedValue}"]`);

        if (option) {
            option.selected = true;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new VliscoContactForm());
